import { Suspense } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { validatePermission, createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import { PERMISSION_TAGS } from '../../constants/permissions';

const ManualSensors = withLazyLoading(() => import('../../pages/manualSensors'));

const manualInputRoutes = [
  {
    path: '/manual-sensors',
    handle: createCrumbHandle('Manual Sensors'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <ManualSensors />
          </Suspense>
        ),
        loader: validatePermission(PERMISSION_TAGS.DataInputTemplate_View_R),
      },
    ]
  },
];

export default manualInputRoutes;
